import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { AccountCard } from '#client/pages/AccountSettings/AccountSettings.style';

export const Card = superstyled({
  tag: AccountCard,
  name: 'MyAccountCallback',
  slot: 'Card',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    maxWidth: '36rem',
    margin: `${theme.spacing(6)} auto`,
  }),
});

export const RecoveryCode = superstyled({
  tag: Text,
  name: 'MyAccountCallback',
  slot: 'RecoveryCode',
  styles: ({ theme }) => ({
    fontFamily: 'monospace',
    letterSpacing: '0.1em',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.grey.dark,
    wordBreak: 'break-all',
  }),
});
